import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  Zap,
  Calendar,
  Users,
  Wallet,
  ShoppingBag,
  Package,
  BarChart3,
  Scissors,
  Clock,
  FileText,
  Store,
  Globe,
  CreditCard,
  Building2,
  PackageSearch,
  Gift,
  Image,
  Tag,
  Paintbrush,
  Bell,
  Lock,
  Info,
  Quote,
  Star,
  TrendingUp,
  ArrowLeftRight,
} from 'lucide-react';

export type NavItem = {
  to: string;
  icon: LucideIcon;
  label: string;
  badge?: number;
  comingSoon?: boolean;
  superAdminOnly?: boolean;
};

export type NavGroup = {
  section: string;
  items: NavItem[];
  /** When true, group renders collapsed by default in the sidebar */
  collapsible?: boolean;
};

export function buildNavGroups(
  tenantId: string,
  _isSuperAdmin: boolean,
  lowStockCount: number
): NavGroup[] {
  return [
    {
      section: 'Studio',
      items: [
        { to: `/${tenantId}/dashboard`, icon: LayoutDashboard, label: 'Today' },
        { to: `/${tenantId}/event-mode`, icon: Zap, label: 'Event Mode' },
        { to: `/${tenantId}/pos`, icon: CreditCard, label: 'POS' },
        { to: `/${tenantId}/events`, icon: Calendar, label: 'Bookings & Events' },
        { to: `/${tenantId}/customers`, icon: Users, label: 'Clients' },
        { to: `/${tenantId}/settings/payments`, icon: Wallet, label: 'Payments' },
        { to: `/${tenantId}/transactions`, icon: ArrowLeftRight, label: 'Transactions' },
      ],
    },
    {
      section: 'Inventory & Products',
      items: [
        {
          to: `/${tenantId}/inventory`,
          icon: Package,
          label: 'Inventory',
          badge: lowStockCount > 0 ? lowStockCount : undefined,
        },
        { to: `/${tenantId}/products`, icon: PackageSearch, label: 'Products' },
        { to: `/${tenantId}/orders`, icon: ShoppingBag, label: 'Orders' },
      ],
    },
    {
      section: 'Insights',
      items: [
        { to: `/${tenantId}/analytics`, icon: BarChart3, label: 'Analytics' },
        { to: `/${tenantId}/reports`, icon: TrendingUp, label: 'Reports' },
        { to: `/${tenantId}/portfolio`, icon: Image, label: 'Portfolio' },
        { to: `/${tenantId}/reviews`, icon: Star, label: 'Reviews' },
        { to: `/${tenantId}/testimonials`, icon: Quote, label: 'Testimonials' },
      ],
    },
    {
      section: 'Settings',
      collapsible: true,
      items: [
        { to: `/${tenantId}/settings/services`, icon: Scissors, label: 'Services & Pricing' },
        { to: `/${tenantId}/settings/availability`, icon: Clock, label: 'Hours & Availability' },
        { to: `/${tenantId}/settings/waivers`, icon: FileText, label: 'Waivers' },
        { to: `/${tenantId}/gift-cards`, icon: Gift, label: 'Gift Cards' },
        { to: `/${tenantId}/promotions`, icon: Tag, label: 'Promotions' },
        { to: `/${tenantId}/settings/storefront`, icon: Store, label: 'Storefront' },
        { to: `/${tenantId}/settings/website`, icon: Globe, label: 'Website' },
        { to: `/${tenantId}/settings/billing`, icon: CreditCard, label: 'Subscription' },
        { to: `/${tenantId}/users`, icon: Users, label: 'Team' },
        { to: `/${tenantId}/settings/workspaces`, icon: Building2, label: 'Workspaces' },
        { to: `/${tenantId}/settings/appearance`, icon: Paintbrush, label: 'Appearance' },
        { to: `/${tenantId}/settings/notifications`, icon: Bell, label: 'Notifications' },
        { to: `/${tenantId}/settings/security`, icon: Lock, label: 'Security' },
        { to: `/${tenantId}/settings/about`, icon: Info, label: 'About' },
      ],
    },
  ];
}
